/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponWithCode } from './BaseCouponWithCode';
const TenantCouponWithCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('tenant')],
    ['tenantId', codecString, 'tenant_id'],
]), BaseCouponWithCode);
export class TenantCouponWithCode extends BaseCouponWithCode {
    static decode(input) {
        return TenantCouponWithCodeParser.decode(input).map(res => new TenantCouponWithCode(res));
    }
    static unsafeDecode(input) {
        return TenantCouponWithCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantCouponWithCodeParser.encode(data);
    }
    static schema() {
        return TenantCouponWithCodeParser.schema();
    }
}
